var render = function render(){var _vm=this,_c=_vm._self._c;return _c('show-admins',{ref:"registerAdmin",attrs:{"is-me":true,"is-deps":false,"title":'Εμφάνιση Διαχειριστών ΜΕ'}})
}
var staticRenderFns = []

export { render, staticRenderFns }